<template>
    <div>
        <a-modal title="编辑色板季型"
                 v-model="editModalVisible"
                 :footer="null"
                 :closable="false"
                 :maskClosable="false"
                 width="685px"
        >
            <div class="season-container" v-if="seasonData">
                
                <div class="svg-container">
                    <svg width="227" height="492" viewBox="0 0 376 812" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <template v-for="(svg,ik) in seasonData.svg ">
                            <path @click="svgSelect(svg)" :key="ik" :d="svg.path" :fill="svg.color"/>
                        </template>
                    </svg>
                </div>
                
                <div class="data-container">
                    
                    <div class="name-block season-block">
                        <div class="name">请输入色板季型名称</div>
                        <div class="input">
                            <at-input class="season-input" v-model="seasonData.name" placeholder="请输入季型名称"/>
                        </div>
                    </div>
                    
                    <div class="season-tips"></div>
                    
                    <div class="color-block season-block">
                        <div class="name">请输入HEX十六进制颜色</div>
                        <div class="input">
                            <at-input class="season-input"
                                      :value="svgItem ? svgItem.color : '' "
                                      :disabled="!svgItem"
                                      placeholder="请输入HEX十六进制颜色" @change="colorChanged"/>
                        </div>
                        <div class="color-container">
                            <input type="color" class="color-input" @input="colorChanged"
                                   :value="svgItem ? svgItem.color : '#dddddd'" :disabled="!svgItem"/>
                            <div class="color-tips">点击选色</div>
                        </div>
                    </div>
                    
                    <div class="save-block">
                        <button class="btn btn-white" @click="cancel">取消</button>
                        <button class="btn" @click="saveChange">保存</button>
                    </div>
                
                </div>
            
            
            </div>
        </a-modal>
    </div>
</template>
<script>
import AtInput from "@/components/AtInput.vue";
import api from "@/repo/api";

export default {
    name: "SeasonColorEditor",
    components: {AtInput},
    props: {
        visible: Boolean,
        item: Object,
        planeId: Number,
        colorId: Number,
    },
    data() {
        return {
            editModalVisible: false,
            seasonData: null,
            svgItem: null,
        }
    },
    watch: {
        visible: {
            handler(newVal) {
                this.$nextTick(() => {
                    this.editModalVisible = newVal
                })
            },
            immediate: true
        },
        item: {
            handler(newVal) {
                this.seasonData = JSON.parse(JSON.stringify(newVal))
            },
            deep: true,
            immediate: true
        }
    },
    mounted() {
    
    },
    methods: {
        modalClose() {
            this.$emit('update:visible', false)
        },
        svgSelect(item) {
            this.svgItem = item
        },
        colorChanged(e) {
            this.$set(this.svgItem, 'color', e.target.value)
        },
        cancel() {
            this.editModalVisible = false
            this.modalClose()
        },
        saveChange() {
            this.$loading.show()
            
            api.post('/ast-color-plane/sync-season-colors', {
                plane_id: this.planeId,
                name: this.seasonData.name,
                svg: this.seasonData.svg,
                key: this.seasonData.key,
                id: this.colorId,
            }).then(res => {
                
                this.$loading.hide()
                
                this.$message.data(res)
                
                if (res.code === 0) {
                    
                    this.modalClose()
                    this.$emit('change', this.seasonData)
                }
            })
        }
    }
}
</script>
<style scoped lang="less">
.svg-container {
    line-height: 0;
}

.season-container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
}

.data-container {
    flex: 1;
    height: 492px;
}

.season-block {
    padding: 24px 16px 16px;
    background: #FAFAFA;
}

.season-input {
    width: 100%;
}

.input {
    margin-top: 16px;
}

.name-block {
    width: 392px;
    height: 124px;
    background: #FAFAFA;
}

.name {
    font-weight: 400;
    font-size: 14px;
    color: #333333;
}

.season-tips {
    width: 196px;
    height: 20px;
    background-image: url("/assets/images/season-color-edit-tips.png");
    background-size: 195px 15px;
    background-position: center;
    background-repeat: no-repeat;
    margin-top: 28px;
}

.color-block {
    margin-top: 8px;
    height: 260px;
}

.color-container {
    flex-direction: column;
    width: 120px;
    height: 120px;
    border-radius: 50%;
    overflow: hidden;
    position: relative;
    margin: 24px auto 0;
    
    input {
        width: 160px;
        height: 160px;
        left: -20px;
        top: -20px;
        position: absolute;
    }
}

.color-input {
    position: relative;
    
    width: 130px;
    height: 130px;
    overflow: hidden;
    border-radius: 50%;
    border: 1px solid #eee;
    
    input {
        border-radius: 50%;
        width: 150px;
        height: 150px;
        position: absolute;
        left: -10px;
        top: -10px;
    }
}

.color-tips {
    position: absolute;
    bottom: 0;
    width: 100%;
    background: #0000006e;
    color: white;
    height: 40px;
    text-align: center;
    padding-top: 7px;
    pointer-events: none;
}

.save-block {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 16px;
}
</style>